import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { from } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { PublicationsService } from 'src/app/Service/publications.service';
import * as _ from "lodash";


declare var $: any

@Component({
  selector: 'app-actualites',
  templateUrl: './actualites.component.html',
  styleUrls: ['./actualites.component.scss']
})
export class ActualitesComponent implements OnInit {

  currentUrl = "";
  outputLg: any;

  constructor(private global: Global, private service: PublicationsService, private route: ActivatedRoute, private router: Router) { }

  slick: any = null;
  dataActualite;
  Id;
  isclicked = false;
  Corps;
  archive = false;

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.outputLg = lg;
      this.currentUrl = this.router.url
      this.route.params.subscribe(params => {
        this.Id = params["id"];
        if (this.Id) {
          this.isclicked = true;
          this.service.getActualitebyId(lg.url, this.Id).subscribe(data => {

            const url = this.router.url;
            if(url.toLocaleLowerCase().indexOf('/archive/')!== -1) {
              this.archive= true;
            }
            this.Corps = '<h3 class="num-appel-offre">' + data["value"][0]["Title"] + '</h3>';
            this.Corps += '<div class="date-appels-details">'+this.converteDate(data["value"][0]["AcualiteDate"])+'</div>';
            this.Corps += data["value"][0]["ActualiteCorps"];
          })
        } else {
          this.isclicked = false;
          this.dataActualite = [];
          this.service.getActualite(lg.url).subscribe(data => {
            this.dataActualite = data["value"];
            if (this.slick != null) {
              this.reload();
            } else {
              setTimeout(() => this.sliderAppel(lg), 100);
            }
          })
        }
      })
    })
  }

  sliderAppel(lg) {
    this.slick = $('.slickappel').dataTable({
      data: this.dataActualite,
      columns: [
        {
          data: 'Title',
          render: (data, type, a) => {
            return  '<a href="javascript:void(0)"  class="block-appels d-flex align-items-start flex-column">' +
                      '<div class="d-flex justify-content-between w-100">' +
                        '<h3 class="num-appel-offre">' + a.Title + '</h3>' +
                        '<div class="date-appels mt-auto" style="width: 100%;max-width: fit-content;">' + this.converteDate(a.AcualiteDate) + '</div>' +
                      '</div>' +
                      '<p class="titre-appels">' + this.getLine(a.ActualiteDescription) + '</p>' +
                    '</a>';
          }
        }
      ],
      "language": {
        "paginate": {
          "previous": '«',
          "next": '»'
        }
      },
      "lengthMenu": [5],
      "ordering": false,
      "searching": false,
      "info": false,
      "lengthChange": false
    });
    var b = this.router;
    $('.slickappel tbody').on('click','tr',function(e){
      var data = $('.slickappel').DataTable().row(this).data();
      b.navigate(['publications/actualites/'+data.ID]);
    });
    //
    //   if (lg.code != "ar") {
    //     if ($('.slickappel').length > 0) {
    //       this.slick = $('.slickappel').slick({
    //         infinite: true,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         dots: true,
    //         customPaging: function(slick,index) {
    //           return '<a>' + (index + 1) + '</a>';
    //         }    
    //       });
    //     }
    //   } else {
    //     this.slick = $('.slickappel').slick({
    //       infinite: true,
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       dots: true,
    //       rtl: true,
    //       customPaging: function(slick,index) {
    //         return '<a>' + (index + 1) + '</a>';
    //       } 
    //     });
    //   }
  }

  reload() {
    $('.slickappel').DataTable().clear();
    $('.slickappel').DataTable().rows.add(this.dataActualite);
    $('.slickappel').DataTable().columns.adjust().draw();
  }
  getLine(s: string) {
    return s.substr(0, 200) + "...";
  }
  converteDate(d: string) {
    return this.global.formattedDate(d);
  }

}
